import React from 'react';
import { useIntl } from 'umi';
import { TYPES_PREFIXS_MAPPING } from '../../_config/constant';

import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IPickerValue, IDateTypeOption } from '../../types';

interface IResultProps extends IBaseProps {
  types: IDateTypeOption[];
  value: IPickerValue;
}

export default function Result(props: IResultProps) {
  const {
    types,
    value: { type = '', value = [] },
  } = props;

  const { formatMessage } = useIntl();

  const prefix: string = (() => {
    const typeObj = types?.find((item) => item?.value === type);
    if (!typeObj?.value) return '';
    return TYPES_PREFIXS_MAPPING?.[typeObj.value];
  })();

  return (
    <div className="range-day-month-selector-result">
      <span className="range-day-month-selector-result-value">
        <span className="text-desc">{formatMessage({ id: 'dbi_range_month_picker_launch' })}</span> {prefix}
        {value[0]} <i>~</i> {prefix}
        {value[1]}
      </span>
      {/* <span className='range-day-month-selector-result-type'>{getLocalText(`competitor_launch_${type}`)}</span> */}
    </div>
  );
}
